import React, {Component} from "react";
import Head from "../../components/Head";
import {withTranslate} from "react-redux-multilingual";
import DoctorsPage from "../../components/doctors/DoctorsPage"
import {connect} from "react-redux";
import globalMiddleware from "../../hocs/globalMiddleware";
import {setCurrentRoute} from "../../store/actions/globalActions";


class Doctor extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
    }

    state = {
        scroll: true,

    };


    render() {
        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];


        return (
            <div>
                <DoctorsPage language={this.props.language} mobileMenuIsShown={this.props.mobileMenuIsShown} isFavourite={false}/>
            </div>
        )
    }


}
const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(Doctor)));